import { GET_ANANDA_PROGRAMS_LIST } from "../../constants";

export function getAnandaProgramsList(data) {
    return {
        type: GET_ANANDA_PROGRAMS_LIST,
        data
    };
}